window.themeEvents = {
	header: {
		predictiveSearch: {
			start: new Event('header:predictiveSearch:start'),
			end: new Event('header:predictiveSearch:end')
		},
		mobileMenu: {
			open: new Event('header:mobilemenu:open'),
			close: new Event('header:mobilemenu:close'),
			enterSubmenu: new Event('header:mobilemenu:enterSubmenu'),
			exitSubmenu: new Event('header:mobilemenu:exitSubmenu')
		}
	},
	products: {
		addToCart: {
			start: new Event('products:addToCart:start'),
			end: new Event('products:addToCart:end')
		},
		removeFromCart: {
			start: new Event('products:removeFromCart:start'),
			end: new Event('products:removeFromCart:end')
		},
		variantSwitch: new Event('products:variantSwitch')
	},
	miniCart: {
		opened: new Event('miniCart:opened'),
		closed: new Event('miniCart:closed'),
		close: new Event('miniCart:close')
	},
	cart: {
		get: {
			start: new Event('cart:get:start'),
			end: new Event('cart:get:end')
		},
		updated: new Event('cart:updated'),
		cleared: new Event('cart:cleared')
	},
	quickshop: {
		addToCart: {
			start: new Event('quickshop:addToCart:start'),
			end: new Event('quickshop:addToCart:end')
		}
	},
	fade: {
		in: {
			end: new CustomEvent('fade:in:end', {
				bubbles: true,
				cancelable: false,
				composed: true,
				detail: {
					description: "Fires when an element was faded in."
				}
			})
		},
		out: {
			end: new CustomEvent('fade:out:end', {
				bubbles: true,
				cancelable: false,
				composed: true,
				detail: {
					description: "Fires when an element was faded out."
				}
			})
		}
	},
	checkout: {
		start: new Event('checkout:start')
	}
};
